import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAiZfDIylsaUIB5xfQOdlC6qKaxUxlMl3g",
  authDomain: "jain-cricket-league.firebaseapp.com",
  databaseURL: "https://jain-cricket-league.firebaseio.com",
  projectId: "jain-cricket-league",
  storageBucket: "jain-cricket-league.appspot.com",
  messagingSenderId: "886224719584",
  appId: "1:886224719584:web:be3d8efa9acf1b23cd0a85",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const auth = getAuth(app);
signInWithEmailAndPassword(
  auth,
  "spa2@gmail.com",
  "qL99rkB9JIZ5gfBdrtTLyiZnhyO3"
).catch(() => {});

export default app;
